import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-send-icon',
  templateUrl: './communication-send.component.html'
})
export class CommunicationSendComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
